<template>
  <div>
    <div
      id="modelInfoModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Help
            </h4>
          </div>
          <div class="modal-body">
            <p>
              To help you decide what is right for you, here are a few examples of what you might do, depending on your aims.
            </p>
            <h4>Jobs and Economic Prosperity</h4>
            <p>
              If you want the region to prosper economically, unemployment should be reduced and it should be easier for people to find a job! In that case you may want to reduce the costs associated with transport, or enhance the capacity of the transport networks. This would make it easier for people to get to work opportunities, for employers to recruit, and for businesses to work with their customers and suppliers.
            </p>
            <h4>Carbon emissions</h4>
            <p>
              You may feel climate change is a real issue and we should focus on reducing carbon emissions from transport! To have the biggest impact here you could speed up the electrification of cars; improve the public transport system to make it a more attractive option for the average person (thereby reducing their use of cars); make car use less attractive by increasing the costs of driving, maybe by bringing in some road pricing, or reducing parking; or try a combination of all of the above!
            </p>
            <h4>Congestion</h4>
            <p>
              You feel there are too many cars on the road and traffic jams should be taken care of! Here, you could improve public transport or discourage car use with road pricing or parking restrictions. You could encourage freight movements to use rail rather than roads, or maybe improve the road network by increasing road capacity. Alternatively you could introduce a car sharing or e-bike scheme to the region.
            </p>
            <p>
              Remember, your choices have implications, some of which may be intentional, but others may not. MCSim will how you how effective you have been, compared to what would happen if you did nothing.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";

export default {
  created() {
    this.$root.$data.eventHub.$on("show-modelinfo-modal", this.displayModal);
  },
  methods: {
    displayModal: function () {
      $("#modelInfoModal").modal("show");
    },
  },
};
</script>

<style lang="scss">
#modelInfoModal .modal-dialog {
  width: 80%;
}
#modelInfoModal {
  .modal-body li {
    list-style-type: none;
    margin: 10px 0;
    padding: 0;
  }
  .modal-body ul {
    margin: 0;
    padding: 0;
  }
  .modal-body p {
    margin: 20px 0;
    text-align: justify;
  }
}
</style>
